export const VENDOR_SAVE = "VENDOR_SAVE"
export const VENDOR_SAVE_COMPANY_DETAILS = "VENDOR_SAVE_COMPANY_DETAILS"
export const VENDOR_SAVE_SOCIAL_MEDIA = "VENDOR_SAVE_SOCIAL_MEDIA"
export const VENDOR_REGISTER_REQUEST = "VENDOR_REGISTER_REQUEST"
export const VENDOR_REGISTER_SUCCESS = "VENDOR_REGISTER_SUCCESS"
export const VENDOR_REGISTER_FAIL = "VENDOR_REGISTER_FAIL"
